import { Component, inject, Input, OnInit } from '@angular/core';
import { GlobalPageHeaderComponent } from '../../global-page-header/global-page-header.component';
import {
  IonButton,
  IonContent,
  ModalController,
} from '@ionic/angular/standalone';
import { NlToBrPipe } from '../../../pipes/nl-to-br.pipe';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-function-en-savoir-plus-modal',
  templateUrl: './function-en-savoir-plus-modal.component.html',
  styleUrls: ['./function-en-savoir-plus-modal.component.scss'],
  imports: [
    GlobalPageHeaderComponent,
    IonButton,
    IonContent,
    NlToBrPipe,
    TranslatePipe,
  ],
})
export class FunctionEnSavoirPlusModalComponent {
  private modalController: ModalController = inject(ModalController);

  @Input() description?: string;

  constructor() {}

  async dismissModal() {
    await this.modalController.dismiss();
  }
}
